<template>
    <div>
        <v-card outlined tile v-bind="{ width, loading }">
            <v-row no-gutters>
                <v-col cols="12">
                    <canvas
                        ref="canvas"
                        v-bind="{
                            width,
                            height,
                        }"
                        v-on="{
                            mousedown,
                            mousemove,
                            mouseup,
                            touchstart,
                            touchmove,
                            touchend,
                        }"
                    >
                    </canvas>
                </v-col>
                <v-col cols="12">
                    <v-divider />
                </v-col>
                <v-col cols="12" md="">
                    <v-btn small text block tile @click="($emit('sync') || true) && sync()">
                        <v-icon small> mdi-refresh </v-icon>
                        <span class="px-8"> 초기화 </span>
                    </v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-divider vertical />
                </v-col>
                <v-col cols="12" md="">
                    <v-btn small text block tile color="secondary" @click="init">
                        <v-icon small> mdi-eraser </v-icon>
                        <span class="px-8"> 다시그리기 </span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: [File, Object], default: null },
        width: { type: [Number, String], default: 440 },
        height: { type: [Number, String], default: 440 },
    },
    data: () => ({
        x: 0,
        y: 0,
        loading: false,
        isDrawing: false,
    }),
    mounted() {
        this.init();
        this.sync();
    },
    watch: {
        value() {
            this.init();
            this.sync();
        },
    },
    methods: {
        init() {
            this.x = 0;
            this.y = 0;
            this.isDrawing = false;
            this.clear();
        },
        sync() {
            let url;
            if (this.value instanceof File) url = URL.createObjectURL(this.value);
            else url = this.value?.url;
            this.clear();

            if (!url) return;

            this.loading = true;

            let img = new Image();
            img.src = url;
            img.onload = () => {
                let canvas = this.$refs["canvas"];
                let ctx = canvas.getContext("2d");
                let scale = Math.min(canvas.width / img.width, canvas.height / img.height);

                let scaledWidth = img.width * scale;
                let scaledHeight = img.height * scale;

                let offsetX = (canvas.width - scaledWidth) / 2;
                let offsetY = (canvas.height - scaledHeight) / 2;

                ctx.drawImage(img, offsetX, offsetY, scaledWidth, scaledHeight);

                if (this.value instanceof File) URL.revokeObjectURL(url);

                this.loading = false;
            };
            img.onerror = () => (this.loading = false);
        },
        emit() {
            let type = "image/png";
            let quality = 1;
            let fileName = "sign.png";

            let canvas = this.$refs["canvas"];
            let base64Url = canvas.toDataURL(type, quality);

            let base64Data = base64Url.split(",")[1];

            let binaryData = atob(base64Data);

            let dataLength = binaryData.length;
            let uint8Array = new Uint8Array(dataLength);

            for (let i = 0; i < dataLength; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
            }

            let blob = new Blob([uint8Array], { type });
            let file = new File([blob], fileName, { type, lastModified: Date.now() });

            this.$emit("input", file);
        },
        clear() {
            let canvas = this.$refs["canvas"];
            if (!canvas) return;

            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        },

        // 드로잉 시작
        mousedown(event) {
            this.x = event.offsetX;
            this.y = event.offsetY;
            this.isDrawing = true;
        },

        // 드로잉 진행
        mousemove(event) {
            if (!this.isDrawing) return;

            this.drawLine(this.x, this.y, event.offsetX, event.offsetY);
            this.x = event.offsetX;
            this.y = event.offsetY;
        },

        // 드로잉 정지
        mouseup(event) {
            if (!this.isDrawing) return;
            this.isDrawing = false;

            this.drawLine(this.x, this.y, event.offsetX, event.offsetY);
            this.x = 0;
            this.y = 0;
            this.emit();
        },

        // 드로잉 시작
        touchstart(event) {
            let canvas = this.$refs["canvas"];
            let ctx = canvas.getContext("2d");

            event.preventDefault(event);
            this.isDrawing = true;
            const touch = event.touches[0];
            const rect = canvas.getBoundingClientRect();

            ctx.beginPath();
            ctx.moveTo(touch.clientX - rect.left, touch.clientY - rect.top);
            ctx.strokeStyle = "black";
            ctx.lineWidth = 1;
        },

        // 드로잉 진행
        touchmove(event) {
            if (!this.isDrawing) return;
            let canvas = this.$refs["canvas"];
            let ctx = canvas.getContext("2d");
            const rect = canvas.getBoundingClientRect();
            const touch = event.touches[0];

            ctx.lineTo(touch.clientX - rect.left, touch.clientY - rect.top);
            ctx.stroke();
        },

        // 드로잉 정지
        touchend(event) {
            this.emit();
        },

        drawLine(x1, y1, x2, y2) {
            let canvas = this.$refs["canvas"];
            let ctx = canvas.getContext("2d");
            ctx.beginPath();
            ctx.strokeStyle = "black";
            ctx.lineWidth = 1;
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        },
    },
};
</script>

<style></style>
